<template>
  <div class="questionnaire-container">
    <!-- 主功能区域 -->
    <div class="main-content">
      <!-- 顶部功能按钮区 -->
      <div class="function-buttons">
        <div>
          <el-button @click="goToCreat()" type="primary" size="medium" class="main-button">
            <i class="el-icon-plus"></i> 自定义创建
          </el-button>
        </div>
        <div class="secondary-buttons">
          <!-- <div class="sub-button" style="cursor: pointer;" @click="handelSecondaryClick({}, -1)">
            <img src="@/assets/images/create06.png" alt="" srcset="">
            <div class="main-title" style="font-size: 18px; font-family: PingFang SC, PingFang SC-Semibold; font-weight: Semibold; text-align: left; color: #2b2f36;">ai创建</div>
            <div class="sub-title" style="width: 68px; height: 23px; border: 1px solid #1877ff; border-radius: 5px; font-size: 12px; font-family: PingFang SC, PingFang SC-Semibold; font-weight: Semibold; text-align: center;
color: #1877ff; line-height: 23px; top: 60px;">免费使用</div>
          </div> -->
          <div class="sub-button" v-for="(btn, index) in secondaryButtons" @click="handelSecondaryClick(btn, index)" :key="index" :style="{cursor: index === 0 ? 'pointer' : 'default'}">
            <img :src="btn.bgImage" alt="" srcset="">
            <div class="main-title" :style="{color: btn.mainColor}">{{ btn.mainTitle }}</div>
            <div class="sub-title" :style="{color: btn.subColor}">{{ btn.subTitle }}</div>
          </div>

        </div>
      </div>

      <!-- 搜索和筛选区 -->
      <div class="search-filter">
        <!-- <el-tabs v-model="activeTab" @tab-click="tabClick" class="category-tabs">
          <el-tab-pane v-for="tab in tabs" :key="tab.id" :label="tab.templateTypeName" :name="tab.templateTypeName">
          </el-tab-pane>
        </el-tabs> -->
        <!-- <div style="display: flex; height: 100%;">
          <div v-for="tab in tabs" :key="tab.id" :class="[selectedTabId === tab.id ? 'tab-active' : 'tab-inactive']" @click="tabClick(tab)">
            <p>{{ tab.templateTypeName }}</p>
            <span></span>
          </div>
        </div> -->
		<div class="tab-container">
		  <div
		    v-for="tab in tabs"
		    :key="tab.id"
		    :class="[selectedTabId === tab.id ? 'tab-active' : 'tab-inactive']"
		    @click="tabClick(tab)"
		    style="flex: 0 0 auto; padding: 0 10px; cursor: pointer;"
		  >
		    <p>{{ tab.templateTypeName }}</p>
		    <span></span>
		  </div>
		</div>

        <div class="search-back">
          <el-image style="width: 23px; height: 25px;margin-left: 10px;"
            :src="require('@/assets/images/searchGray.png')" fit="contain">
          </el-image>
          <input placeholder="搜索问卷模板" class="search-input" v-model="searchQuery">
          </input>
          <div class="right-search" @click="searchClick">
            <el-image style="width: 20px; height: 20px" :src="require('@/assets/images/whiteSearch.png')" fit="contain">
            </el-image>
          </div>

        </div>

      </div>

      <!-- 问卷模板卡片区 -->
      <div class="template-grid">
        <el-card :body-style="{ padding: '10px' }" v-for="(template, index) in templates" :key="index"
          class="template-card" shadow="hover">
          <div class="template-title">{{ template.templateQuestionnaireName }}</div>
          <div class="template-desc">{{ template.keyword }}</div>
          <div style="width: 100%;background-color: #D8D8D8;height: 1px;margin-top: 15px;"></div>
          <div class="template-meta">
            <span>{{ template.questionNum }}题</span>
            <span>{{ template.useNum ? template.useNum : '0' }}次使用</span>
          </div>
          <div class="look-btn" @click="handleSeeDetail(template.uuid)">
            查看
          </div>
        </el-card>
      </div>

      <!-- 分页区 -->
      <div class="pagination">
        <el-pagination background layout="prev, pager, next" :page-size="pageSize" :total="totalTemplates"
          @current-change="handlePageChange">
        </el-pagination>
      </div>

      <questionTemplate :showDialog="showDialog" @close-dialog="showDialog = false" :params="{id: lookId, type: 1}"></questionTemplate>
    </div>
  </div>
</template>


<script>
import { templateList, questionnaireTemplateList } from '@/api/index.js'
import questionTemplate from "@/components/QuestionTemplate/index.vue";
export default {
  components: {
    questionTemplate
  },
  data() {
    return {
      // 主按钮
      mainButton: {
        label: '自定义创建',
        type: 'primary'
      },

      // 次要按钮
      secondaryButtons: [
        // { mainTitle: '数据无忧', subTitle: '从问卷发不到数据回收，获取最详实信息', mainColor: '#F99735', subColor: '#F99735', bgImage: require('@/assets/images/create01.svg') },
        { mainTitle: '', subTitle: '', mainColor: '', subColor: '', bgImage: require('@/assets/images/create07.png') },
        { mainTitle: '多彩问卷', subTitle: '汇聚多样主题模板，精准捕捉各方需求', mainColor: '#37B1BB', subColor: '#37B1BB', bgImage: require('@/assets/images/create02.svg') }, 
        { mainTitle: '极简操作', subTitle: '极简操作，逻辑清晰，智慧调研一键启航', mainColor: '#5E6EF9', subColor: '#5E6EF9', bgImage: require('@/assets/images/create03.svg') },
        { mainTitle: '多元题型', subTitle: '拥有丰富多元的题型库，满足各类调研需求', mainColor: '#EA5F59', subColor: '#EA5F59', bgImage: require('@/assets/images/create08.png') },
        { mainTitle: '实时反馈', subTitle: '实时反馈数据，直观图表展示一目了然', mainColor: '#248FDF', subColor: '#248FDF', bgImage: require('@/assets/images/create05.svg') },
      ],

      // 标签页
      activeTab: '全部',
      templateTypeId: '',
      tabs: [
        // { label: '全部', name: 'all' },
        // { label: '企业问卷', name: 'enterprise' },
        // { label: '市场问卷', name: 'market' },
        // { label: '满意度调查', name: 'satisfaction' }
      ],

      // 搜索
      searchQuery: '',

      // 模板数据
      templates: [

      ],

      // 分页
      currentPage: 1,
      pageSize: 30,
      totalTemplates: 0,
      showDialog: false,
	  lookId: null,
    selectedTabId: '',
    }
  },
  created() {
    // 获取问卷模板数据
    this.getData();
    this.getTypes();

    console.log("o1ir21ur19ru210ru120r192ur0912u2r9012", this.$store.getters['question/getQuestionType']);
    
  },
  methods: {
    tabClick(e) {
      // console.log(this.activeTab,e);
      this.selectedTabId = e.id;
      this.templateTypeId = e.id;
      this.currentPage = 1;
      this.getData();

      // for (const key in this.tabs) {
      //   let item = this.tabs[key];
      //   if (item.templateTypeName == this.activeTab) {
      //     this.templateTypeId = item.id;
      //     this.getData();
      //   }
      // }
    },
    goToCreat() {
      this.$router.push({ path: '/create' });
    },

    getTypes() {

      templateList().then(res => {
        console.log(res, '类型数据');
        this.tabs.push({ templateTypeName: '全部', id: '' })
        this.tabs.push(...res.data);
      })
    },

    searchClick() {
      this.currentPage = 1;
      this.getData();
    },
    getData() {
      questionnaireTemplateList({ 
        'pageNum': this.currentPage, 
        'pageSize': this.pageSize,
        'templateTypeId': this.templateTypeId, 
        'templateQuestionnaireName': this.searchQuery == '' ? undefined : this.searchQuery 
      }).then(res => {
        console.log(res, '列表数据');
        this.templates = res.rows;
        this.totalTemplates = res.total;
      })
    },
    viewTemplate() {

    },


    handlePageChange(page) {
      this.currentPage = page
      // 这里可以添加获取新页数据的逻辑
      console.log('切换到页码:', page)
      this.getData();
    },
    handleSeeDetail(id) {
      this.showDialog = true;
	  this.lookId = id;
    },
    handelSecondaryClick(btn, index) {
      console.log(btn, index);
      if (index == 0) {
        this.$router.push({ path: '/AiCreate' });
      }
    }
  }
}
</script>

<style scoped>
/* 全局样式调整 */
body {
  margin: 0;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}

/* 容器样式 */
.questionnaire-container {
  /* min-height: 100vh; */
  /* margin-top: 35px; */
  /* background-color: #f5f7fa; */
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
}

/* 顶部蓝色横幅 */
.top-banner {
  background-color: #409EFF;
  color: white;
  padding: 30px 0;
  margin-bottom: 20px;
}

.banner-content {
  /* max-width: 1200px; */
  margin: 0 auto;
  padding: 0 20px;
}

.banner-content h2 {
  font-size: 24px;
  margin: 0 0 10px 0;
}

.banner-content p {
  font-size: 14px;
  margin: 0;
  opacity: 0.9;
}

/* 主内容区域 */
.main-content {
  /* max-width: 900px; */
  /* margin: 10px auto; */
  width: 1233px;
  margin: 0 auto;
  /* padding: 0 10px; */
}

/* 功能按钮区 */
.function-buttons {
  display: flex;
  margin-bottom: 10px;
  align-items: center;
}

.main-button {
  /* border-radius: 20px; */
  /* padding: 10px 20px; */
  width: 197px;
  height: 116px;
  background: linear-gradient(180deg, #1877ff, #5a9eff);
  border-radius: 5px;
  font-size: 18px;
}

.secondary-buttons {
  /* margin-left: 10px; */
  display: flex;
  flex-wrap: nowrap;

}

.sub-button {
  /* padding: 0 12px; */
  color: #606266;
  font-size: 14px;
  width: 197px;
  height: 116px;
  /* background: #ffffff; */
  border-radius: 5px;
  /* flex-wrap: nowrap; */
  margin-left: 10px;
  display: flex;
  align-items: left;
  flex-direction: column;
  justify-content: center;
  position: relative;

  img {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }

  .main-title {
    position: absolute;
    font-size: 17px;
    font-family: PingFang SC, PingFang SC-Semibold;
    font-weight: 500;
    text-align: left;
    left: 16px;
    top: 16px;
  }

  .sub-title {
    position: absolute;
    font-size: 13px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: left;
    left: 16px;
    top: 46px;
    width: 120px;
  }
}

.top-button {
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 500;
  text-align: left;
  color: #2b2f36;
  line-height: 22px;
  margin-left: 26px;
}

.search-back {
  width: 443px;
  height: 45px;
  background: #f8f8f8;
  border: 0.68px solid #e8e8e8;
  border-radius: 26px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 10px;
}

/* 搜索和筛选区 */
.search-filter {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  align-items: center;

  width: 1233px;
  height: 63px;
  background: #ffffff;
}

.right-search {
  width: 56px;
  height: 35px;
  background: #1877ff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 26px;
  margin-right: 10px;
}

.category-tabs {
  margin-left: 10px;
  flex-grow: 1;
  margin-top: 40px;
}

.category-tabs>>>.el-tabs__item {
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  padding: 0 8px;
}

.el-tabs__item is-active {
  color: #323B5A;
}

.category-tabs>>>.el-tabs__nav-wrap::after {
  height: 3px;
  background-color: white;
}

.search-input {
  width: 100%;
  margin-left: 10px;
  height: 100%;
  background-color: #f8f8f8;
}

input:focus {
  outline: none;
}

.search-input>>>.el-input__inner {
  /* border-radius: 20px; */
  height: 80px;
  line-height: 80px;
}

/* 模板卡片样式 */
.template-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 10px;
  margin-bottom: 40px;
}

.template-card {
  width: 197px;
  height: 195px;
  background: #ffffff;
  border: 1px solid #e3e3e3;
  border-radius: 5px;
}

.el-card__body {
  /* padding: 10px; */

}

.template-card:hover {
  /* transform: translateY(-5px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1); */
}

.template-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  line-height: 1.4;
}

.look-btn {
  width: 175px;
  height: 35px;
  background: #1877ff;
  border-radius: 26px;
  text-align: center;
  color: white;
  line-height: 35px;
  margin-top: 15px;
  font-size: 14px;
  cursor: pointer;
}

.template-desc {
  font-size: 14px;
  color: #666;
  flex-grow: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 1.5;
  margin-bottom: 10px;
  height: 44px;
}

.template-meta {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #999;
  margin: 10px 0;
}

.view-button {
  width: 100%;
  border-radius: 4px;
  height: 36px;
}

/* 分页样式 */
.pagination {
  display: flex;
  justify-content: right;
  /* padding-bottom: 40px; */
}

.pagination>>>.el-pagination.is-background .el-pager li {
  border-radius: 4px;
  margin: 0 4px;
}

.pagination>>>.el-pagination.is-background .btn-prev,
.pagination>>>.el-pagination.is-background .btn-next {
  border-radius: 4px;
}

.tab-active {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin-left: 24px;
  cursor: pointer;

  p {
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: 600;
    text-align: left;
    color: #323b5a;
    line-height: 20px;
    text-shadow: 0px 0px 18px 0px rgba(0,0,0,0.18); 
    margin-top: 24px;
  }

  span {
    display: block;
    width: 23px;
    height: 4px;
    background: #1877ff;
    border-radius: 2px;
    box-shadow: 0px 0px 18px 0px rgba(0,0,0,0.18); 
  }
}

.tab-inactive {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  /* margin-left: 24px; */
  cursor: pointer;

  p {
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: Medium;
    text-align: left;
    color: #a7adc6;
    line-height: 20px;
    text-shadow: 0px 0px 18px 0px rgba(0,0,0,0.18); 
    margin-top: 24px;
  }
}

.tab-container {
  display: flex;
  overflow-x: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
}

.tab-container::-webkit-scrollbar {
  height: 5px;
}

.tab-container::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 3px;
}

.tab-container::-webkit-scrollbar-track {
  background: transparent;
}

.tab-container.no-scrollbar::-webkit-scrollbar {
  display: none;
}
.tab-container.no-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

</style>


// WEBPACK FOOTER //
// src/views/HomePage/index.vue